export const PRODUCT_EVENT_NAMES = [
  'auth_login_submitted',
  'auth_signup_submitted',
  'auth_google_oauth_started',
  'auth_password_reset_requested',
  'auth_password_updated',
  'auth_signout_clicked',
  'jobs_manual_job_created',
  'jobs_bulk_manual_jobs_created',
  'jobs_manual_job_updated',
  'jobs_manual_job_deleted',
  'jobs_filters_applied',
  'jobs_filters_reset',
  'jobs_export_requested',
  'jobs_suitespot_sync_triggered',
  'jobs_service_dates_saved',
  'jobs_labels_changed',
  'jobs_addon_quote_submitted',
  'jobs_building_linked',
  'recurring_template_created',
  'recurring_template_updated',
  'recurring_template_deleted',
  'schedule_items_filters_applied',
  'schedule_items_export_requested',
  'schedule_items_note_mutation_completed',
  'schedule_items_addon_mutation_completed',
  'schedule_items_vendor_progress_updated',
  'schedule_items_subcontractor_override_changed',
  'schedule_items_touch_up_changed',
  'tentative_jobs_upload_saved',
  'tentative_job_manual_created',
  'tentative_job_manual_updated',
  'tentative_job_manual_deleted',
  'contacts_mutation_completed',
  'contacts_bulk_import_synced',
  'contacts_openphone_linked_or_created',
  'contacts_openphone_sync_state_changed',
  'contacts_openphone_message_sent',
  'sync_incremental_command_triggered',
  'sync_manual_command_triggered',
  'users_invite_sent',
  'users_membership_changed',
  'admin_configuration_mutation_completed',
  'vendor_schedule_install_prompt_interacted',
  'vendor_schedule_install_completed',
  'command_palette_opened',
  'command_palette_result_selected',
] as const

export type ProductEventName = (typeof PRODUCT_EVENT_NAMES)[number]
export type ProductEventResult = 'success' | 'failure'

export type ProductEventInput = {
  event: ProductEventName
  action: string
  result: ProductEventResult
  surface: string
  entityId?: string | number | null
  error?: unknown
  properties?: Record<string, unknown>
  distinctId?: string
}

export const PRODUCT_EVENT_PROPERTY_ALLOWLIST = new Set([
  'action',
  'result',
  'surface',
  'error_class',
  'error_code',
  'operation',
  'target',
  'source',
  'provider',
  'method',
  'status_code',
  'count',
  'total_count',
  'selected_count',
  'skipped_count',
  'filter_count',
  'command',
  'mode',
  'requested_format',
  'delivered_format',
  'fallback_used',
  'entity_id_hash',
])
